import Req from '../../$axios';

const serviceModule = {
  historyMessageLogs(params) {
    //获取项目下某天的所有消息记录
    let data = { ...params, api_version: 'v2' }
    return Req(
      {
        url: 'projectMessages/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      data
    )
  },
  setMessageRead(params) {
    // 使全部已读
    return Req(
      {
        url: 'projectMessages/setMessageRead',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  setTaskAndChildrenTaskMessageRead(params) {
    // 设置任务已读
    return Req(
      {
        url: 'projectMessages/setTaskAndChildrenTaskMessageRead',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getNumberOfUnreadMessages(params) {
    // 获取未读消息数量
    return Req(
      {
        url: 'projectMessages/getNumberOfUnreadMessages',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
};
